// src/store/authStore.js
import { create } from "zustand";
import axiosToken from "../api/axiosClient";
import { toast } from "react-toastify";

const useAuthStore = create((set, get) => ({
  user: null,
  isLoading: false,
  error: null,

  // 🔄 Récupérer les infos utilisateur
  getUser: async () => {
    set({ isLoading: true, error: null });
    try {
      const response = await axiosToken.get("/user/profil");
      set({ user: response.data, isLoading: false });
      // console.log(" getUser :", response.data);
      return response.data;
    } catch (error) {
      console.error("Erreur getUser :", error);
      set({ error: error.message, isLoading: false });
      return null;
    }
  },

  // 🔐 Déconnexion
  logout: async () => {
    try {
      localStorage.removeItem("authToken");
      toast.success("Vous êtes déconnecté!");
      await axiosToken.post("/auth/logout"); // ou ton endpoint logout
    } catch (error) {
      console.error("Erreur logout :", error);
    } finally {
      set({ user: null });
    }
  },

  // ✏️ Mise à jour du profil
  updateUser: async (updatedData) => {
    set({ isLoading: true, error: null });
    try {
      const response = await axiosToken.put("/user/profil", updatedData);
      set({ user: response.data, isLoading: false });
      return response.data;
    } catch (error) {
      console.error("Erreur updateUser :", error);
      set({ error: error.message, isLoading: false });
      return null;
    }
  },
}));

export default useAuthStore;
